<h3 class="text-md py-4 font-bold">Water</h3>

<form
  #form="ngForm"
  novalidate
>
  <div class="flex flex-col gap-1">
    <nsp-checkbox-input
      id="fwgNonFunctional"
      name="fwgNonFunctional"
      label="FWG Non-Functional"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('fwgNonFunctional')"
      [readonly]="isFieldReadOnly('fwgNonFunctional')"
      [value]="consumptionsStore.water().fwgNonFunctional.value"
      [ngModel]="consumptionsStore.water().fwgNonFunctional.value"
    />
    <nsp-number-input
      id="freshWaterProduced"
      name="freshWaterProduced"
      label="Fresh Water Produced"
      [labelWidthPercentage]="33"
      [unit]="'MT'"
      [required]="isFieldRequired('freshWaterProduced')"
      [disabled]="consumptionsStore.water().fwgNonFunctional.value!"
      [value]="consumptionsStore.water().freshWaterProduced.value"
      [ngModel]="consumptionsStore.water().freshWaterProduced.value"
    />
    <nsp-number-input
      name="distilledWaterProduced"
      id="distilledWaterProduced"
      label="Fresh Water Produced"
      [labelWidthPercentage]="33"
      [unit]="'MT'"
      [required]="isFieldRequired('distilledWaterProduced')"
      [disabled]="consumptionsStore.water().fwgNonFunctional.value!"
      [value]="consumptionsStore.water().distilledWaterProduced.value"
      [ngModel]="consumptionsStore.water().distilledWaterProduced.value"
    />
  </div>
</form>
